import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

function Badge({ color, badgeText }) {
    const containerClassNames = [
        'product-badge',
        'product-badge--' + color
    ].join(' ');

    return (
        <Translation
            tagName="div"
            translationKey={badgeText}
            placeholder={{}}
            className={containerClassNames}
        />
    );
}

Badge.propTypes = {
    color: PropTypes.string.isRequired,
    badgeText: PropTypes.string.isRequired,
};

export { Badge };
